import { render, staticRenderFns } from "./TestMenu.vue?vue&type=template&id=aaec9474"
import script from "./TestMenu.vue?vue&type=script&lang=ts"
export * from "./TestMenu.vue?vue&type=script&lang=ts"
import style0 from "./TestMenu.vue?vue&type=style&index=0&id=aaec9474&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports